"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BankService {
    bankRepository;
    constructor(bankRepository) {
        this.bankRepository = bankRepository;
    }
    async listBanks() {
        const response = await this.bankRepository.listBanks();
        const banks = response.map((bank) => {
            let funds = [];
            if (bank.funds) {
                funds = bank.funds.map((fund) => ({
                    id: fund.id,
                    number: fund.account.number,
                    type: fund.account.type,
                }));
            }
            return {
                id: bank.id,
                name: bank.name,
                funds,
            };
        });
        const banksWithBcpCci = response.find((bank) => bank.id === '1');
        banks.push({
            id: '0',
            name: 'Otros bancos',
            funds: banksWithBcpCci?.funds.map((f) => ({
                id: f.id,
                number: f.account?.cci,
                type: f.account?.type,
            })),
        });
        const defaultCci = banksWithBcpCci
            ? banksWithBcpCci?.funds
                ?.map((f) => ({
                [f.id]: f.account.cci,
            }))
                ?.reduce((a, v) => ({ ...a, ...v }), {})
            : {};
        return {
            banks,
            defaultCci,
        };
    }
}
exports.default = BankService;
//# sourceMappingURL=BankServiceImpl.js.map